/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { PrefixContext } from '../../internal/usePrefix.js';
import React__default from 'react';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const LowerHandle = () => /*#__PURE__*/React__default.createElement(PrefixContext.Consumer, null, prefix => /*#__PURE__*/React__default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 24",
  className: `${prefix}--slider__thumb-icon ${prefix}--slider__thumb-icon--lower`
}, _path || (_path = /*#__PURE__*/React__default.createElement("path", {
  d: "M15.08 6.46H16v11.08h-.92zM4.46 17.54c-.25 0-.46-.21-.46-.46V6.92a.465.465 0 0 1 .69-.4l8.77 5.08a.46.46 0 0 1 0 .8l-8.77 5.08c-.07.04-.15.06-.23.06Z"
})), _path2 || (_path2 = /*#__PURE__*/React__default.createElement("path", {
  fill: "none",
  d: "M-4 0h24v24H-4z"
}))));
const LowerHandleFocus = () => /*#__PURE__*/React__default.createElement(PrefixContext.Consumer, null, prefix => /*#__PURE__*/React__default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 24",
  className: `${prefix}--slider__thumb-icon ${prefix}--slider__thumb-icon--lower ${prefix}--slider__thumb-icon--focus`
}, _path3 || (_path3 = /*#__PURE__*/React__default.createElement("path", {
  d: "M15.08 6.46H16v11.08h-.92zM4.46 17.54c-.25 0-.46-.21-.46-.46V6.92a.465.465 0 0 1 .69-.4l8.77 5.08a.46.46 0 0 1 0 .8l-8.77 5.08c-.07.04-.15.06-.23.06Z"
})), _path4 || (_path4 = /*#__PURE__*/React__default.createElement("path", {
  fill: "none",
  d: "M-4 0h24v24H-4z"
})), _path5 || (_path5 = /*#__PURE__*/React__default.createElement("path", {
  d: "M15.08 0H16v6.46h-.92z"
})), _path6 || (_path6 = /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h.92v24H0zM15.08 0H16v24h-.92z"
})), _path7 || (_path7 = /*#__PURE__*/React__default.createElement("path", {
  d: "M0 .92V0h16v.92zM0 24v-.92h16V24z"
}))));
const UpperHandle = () => /*#__PURE__*/React__default.createElement(PrefixContext.Consumer, null, prefix => /*#__PURE__*/React__default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 24",
  className: `${prefix}--slider__thumb-icon ${prefix}--slider__thumb-icon--upper`
}, _path8 || (_path8 = /*#__PURE__*/React__default.createElement("path", {
  d: "M0 6.46h.92v11.08H0zM11.54 6.46c.25 0 .46.21.46.46v10.15a.465.465 0 0 1-.69.4L2.54 12.4a.46.46 0 0 1 0-.8l8.77-5.08c.07-.04.15-.06.23-.06Z"
})), _path9 || (_path9 = /*#__PURE__*/React__default.createElement("path", {
  fill: "none",
  d: "M-4 0h24v24H-4z"
}))));
const UpperHandleFocus = () => /*#__PURE__*/React__default.createElement(PrefixContext.Consumer, null, prefix => /*#__PURE__*/React__default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 24",
  className: `${prefix}--slider__thumb-icon ${prefix}--slider__thumb-icon--upper ${prefix}--slider__thumb-icon--focus`
}, _path10 || (_path10 = /*#__PURE__*/React__default.createElement("path", {
  d: "M0 6.46h.92v11.08H0zM11.54 6.46c.25 0 .46.21.46.46v10.15a.465.465 0 0 1-.69.4L2.54 12.4a.46.46 0 0 1 0-.8l8.77-5.08c.07-.04.15-.06.23-.06Z"
})), _path11 || (_path11 = /*#__PURE__*/React__default.createElement("path", {
  fill: "none",
  d: "M-4 0h24v24H-4z"
})), _path12 || (_path12 = /*#__PURE__*/React__default.createElement("path", {
  d: "M.92 24H0v-6.46h.92z"
})), _path13 || (_path13 = /*#__PURE__*/React__default.createElement("path", {
  d: "M16 24h-.92V0H16zM.92 24H0V0h.92z"
})), _path14 || (_path14 = /*#__PURE__*/React__default.createElement("path", {
  d: "M16 23.08V24H0v-.92zM16 0v.92H0V0z"
}))));

export { LowerHandle, LowerHandleFocus, UpperHandle, UpperHandleFocus };
